<template>
		<div class="test-list">
			<div class="sub-head">
				<div class="test-title">练习列表</div>
				<div class="subject">
					<div class="tab" v-for="(item,index) in tabList" :key="index" :class="actTab==item.id?'actTab':''" @click="getSubject(item.id)">{{item.name}}</div>
				</div>
			</div>	
			<div class="test-cont">
				<div class="test-card" @click="goList(item)" v-for="(item,index) in testList" :key="index">
					<div class="test-bg" :style="{backgroundImage:`url(${item.coverImg})`}">
						<!-- <div v-if="item.isComplete" class="test-study test-study-end">已完成</div>
						<div v-else-if="item.isContinue" class="test-study">继续学习</div> -->
						<img v-if="item.ruo" class="test-ruo" src="../assets/ruo-icon.png" alt="" />
					</div>
					<!-- <div class="test-text">{{item.point_info}}</div> -->
					<div class="test-btn">
						<div class="test-name">{{item.point_name}}</div>
						<!-- <img class="test-avator" :src="item.avator" alt="" /> -->
						<!-- <span class="test-teacher">{{item.teacher}}</span> -->
						<div v-if="item.isCollect" class="test-save test-save-act" @click.stop="collect(item)"></div>
						<div v-else class="test-save" @click.stop="collect(item)"></div>
					</div>
				</div>
			</div>
		</div>
</template>
<script>

export default {
	name: 'index',

	components: {},

	data(){
		return {
			num:9999,//课数量
			actTab:localStorage.getItem('actTab')||1,
			userInfo:JSON.parse(localStorage.getItem('userInfo')),
			testList:[],
			collectList:[],
			tabList:[
				{
					id:1,
					name:'数学'
				},
				{
					id:2,
					name:'英语'
				},
				{
					id:3,
					name:'物理'
				},
			]
		}
	},

	created(){
		if(localStorage.getItem('routeType') == 'home'){
			localStorage.removeItem('routeType')
			this.goList(JSON.parse(this.$route.query.item));
			return;
		}
		// this.setTab();
		if(!this.actTab){
			localStorage.removeItem('actTab');
			this.$message('当前没有学习权限，请联系老师');
			return;
		}
		this.init();
	},
	mounted() {

	},

	computed: {

	},
	watch: {

	},
	methods: {
		// setTab(){
		// 	if(this.userInfo.authIds.indexOf(2)!=-1&&localStorage.getItem("schoolType") == "C"){//初中数学
		// 		this.tabList.push({
		// 			id:1,
		// 			name:'数学'
		// 		})
		// 		this.actTab = 1;
		// 	}
		// 	if(this.userInfo.authIds.indexOf(1)!=-1&&localStorage.getItem("schoolType") == "C"){//初中英语
		// 		this.tabList.push({
		// 			id:2,
		// 			name:'英语'
		// 		})
		// 		if(!this.actTab){
		// 			this.actTab = 2;
		// 		}
		// 	}
		// 	if(this.userInfo.authIds.indexOf(4)!=-1&&localStorage.getItem("schoolType") == "G"){//高中数学
		// 		this.tabList.push({
		// 			id:1,
		// 			name:'数学'
		// 		})
		// 		this.actTab = 1;
		// 	}
		// 	if(this.userInfo.authIds.indexOf(3)!=-1&&localStorage.getItem("schoolType") == "G"){//高中英语
		// 		this.tabList.push({
		// 			id:2,
		// 			name:'英语'
		// 		})
		// 		if(!this.actTab){
		// 			this.actTab = 2;
		// 		}
		// 	}
		// },
		setTab(){
			if(!this.userInfo.authIds){
				return '授权时间已过，请联系相关老师开通新的授权。'
			}
			if(this.actTab == 1){
				if(this.userInfo.authIds.indexOf(3)==-1&&localStorage.getItem("schoolType") == "C"){//初中数学
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
				if(this.userInfo.authIds.indexOf(4)==-1&&localStorage.getItem("schoolType") == "G"){//高中数学
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
			}else if(this.actTab == 2){
				if(this.userInfo.authIds.indexOf(1)==-1&&localStorage.getItem("schoolType") == "C"){//初中英语
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
				if(this.userInfo.authIds.indexOf(2)==-1&&localStorage.getItem("schoolType") == "G"){//高中英语
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
			}else if(this.actTab == 3){
				if(this.userInfo.authIds.indexOf(5)==-1&&localStorage.getItem("schoolType") == "C"){//初中物理
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
				if(this.userInfo.authIds.indexOf(6)==-1&&localStorage.getItem("schoolType") == "G"){//高中物理
					return '授权时间已过，请联系相关老师开通新的授权。'
				}
			}
			return false
		},
		async init(){
			await this.getWeaknessList();
			await this.getCollectList();//获取收藏清单
			await this.getLearnList(true);
			await this.getLearnList(false);
			if(localStorage.getItem('testHot')||localStorage.getItem('courseHot')){//用户产生行为了
				this.getWeakness();//调取清单各项数据
			}else{
				this.getMenuList();//不产生行为直接调取id集合
			}
		},
		async getMenuList() {
			let jsondata = {
				type: 2,
				subject:this.actTab
			}
			const res = await this.$api.getMenuList(jsondata);
			if (res.data.success) {
				if(res.data.data.length==0){//集合没数据调取清单数据
					this.getWeakness();
				}else{//有数据用id集合拉取指定知识点
					this.getTestList({
						idList:res.data.data,//知识点id
					});
				}
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getMenuAdd() {
			let pointIds = this.testList.map(course => course.id);
			let jsondata = {
				type: 2,
				pointIds:pointIds,
				subject:this.actTab
			}
			const res = await this.$api.getMenuAdd(jsondata);
			if (res.data.success) {
				//更新知识点id集合
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getWeakness(){
			//用清单换知识点
			this.getTestList({
				ruoList:this.ruoIdList,//个人弱点清单（知识点）
				ruoPublicList:await this.getWeaknessTopList(),//大众弱点清单（知识点）
				collectList:this.collectList,//我的收藏清单（知识点）
				completeList:this.completeList,//完课清单（知识点）
				questionList:this.questionList,//学习记录
				num:this.num,//课数量
			});
		},
		async getTestList(actjson) {
			let grades;
			if(localStorage.getItem("schoolType")){
				grades = localStorage.getItem("schoolType") === "C" ? '初中' : '高中';
			}
			let jsondata = {
				phone:this.userInfo.accountCode,//手机号
				subject:this.actTab,//学科
				city:this.userInfo.cityId,//城市
				school:this.userInfo.schoolId,//学校
				level:grades||this.userInfo.gradeClass.split("/")[0],//年级
				pid:"w7398uoaiIAF98wu",//pid
				user_id:JSON.parse(localStorage.getItem('userInfo')).qfUserId,
				ruoList:[],//个人弱点清单（知识点）
				ruoPublicList:[],//大众弱点清单（知识点）
				collectList:[],//我的收藏清单（知识点）
				completeList:[],//完课清单（知识点）//视频课播完/直播课奇峰返回完成状态
				questionList:[//学习记录
				],
				num:20,//课数量
			};
			const res = await this.$api.getTestList({...jsondata,...actjson});
			if (res.data.code === 0) {
				this.testList = res.data.data
				// localStorage.removeItem('testHot')
				this.getMenuAdd();
				//设置收藏
				if (this.collectList && this.collectList.length > 0) {
				    this.testList.forEach(course => {
				        if (this.collectList.includes(course.id.toString())) {
				            course.isCollect = true;  // 设置收藏
				        }
				    });
				}
				//设置弱点
				if (this.ruoIdList && this.ruoIdList.length > 0) {
				    this.testList.forEach(course => {
				        if (this.ruoIdList.includes(course.id.toString())) {
				            course.ruo = true;  // 设置收藏
				        }
				    });
				}
				
				//设置完成记录
				if (this.completeList && this.completeList.length > 0) {
				    this.testList.forEach(course => {
				        if (this.completeList.includes(course.id.toString())) {
				            course.isComplete = true;  // 设置已完成
				        }
				    });
				}
				
				//设置学习记录
				if (this.questionList && this.questionList.length > 0) {
				    this.questionList.forEach(questionItem => {
				      this.testList.forEach(courseItem => {
				        if (questionItem.point_id == courseItem.id) {
				          courseItem.isContinue = true;
				        }
				      });
				    });
				}
				
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getWeaknessList() {
			const res = await this.$api.getWeaknessList({
				subject:this.actTab,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type:2,
			});
			if (res.data.success) {
				this.ruoIdList = res.data.data.map(item => item.pointId);
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getWeaknessTopList() {
			const res = await this.$api.getWeaknessTopList({
				subject:this.actTab,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type:2,
			});
			if (res.data.success) {
				return res.data.data;
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async getLearnList(isComplete){
			const res = await this.$api.getLearnQfList({
				subject:this.actTab,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type:2,
				isComplete:isComplete
			});
			if (res.data.success) {
				let resData = [];  // 确保 resData 是一个空数组
				if(isComplete){
					res.data.data.forEach(item => {
					  resData.push(item.pointId);  // 将每个子项的 pointId 推入 this.resData 数组
					});
					this.completeList = resData;
				}else{					
					res.data.data.forEach(item => {
					  // 创建 resData 的单个对象，并设置 point_id
					  const resItem = {
					    point_id: item.pointId,
					    children: []  // 初始化 children 数组
					  };
					
					  // 遍历当前 item 的 children 数组
					  item.children.forEach(child => {
					    resItem.children.push({
					      id: child.businessId,  // 设置 id 为 businessId
					      status: child.bingo?1:2  // 设置 status 为 1
					    });
					  });
					
					  // 将构造好的 resItem 推入到 resData 中
					  resData.push(resItem);
						this.questionList = resData;
					});
				}
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		async collect(item) {
			let jsondata = {
				pointId:item.id,
				type: 2,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				subject:this.actTab
			};
			if(item.isCollect){
				const res = await this.$api.getCollectRemove(jsondata);
				if (res.data.success) {
					this.$message.success('取消收藏成功')
					localStorage.setItem('testHot',true);
					this.init();
				} else {
					this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
				}
			}else{
				const res = await this.$api.getCollectAdd(jsondata);
				if (res.data.success) {
					this.$message.success('收藏成功')
					localStorage.setItem('testHot',true);
					this.init();
				} else {
					this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
				}
			}
		},
		async getCollectList() {
			const res = await this.$api.getCollectList({
				subject:this.actTab,
				level:localStorage.getItem("schoolType") === "C" ? 1 : 2,
				type: 2,
			});
			if (res.data.success) {
				this.collectList = res.data.data;
			} else {
				this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
			}
		},
		goList(item){
			let msg = this.setTab();
			if(msg){
				this.$message.warning(msg);
				return;
			}
			this.$router.push({  //核心语句
			  path:'/testDetail',   //跳转的路径
			  query:{
					id:item.id||item.point_id,
					point_name:item.point_name,
					point_info:item.point_info,
					subject:item.subject=='数学'||item.subject==1?1:2,
				}
			})
		},
		getSubject(i){
			this.actTab = i;
			localStorage.setItem('actTab',i);
			this.init();
		},
	}
}
</script>

<style lang="scss" scoped>
.test-list{
	padding: 1.5rem 0 5rem 0.75rem;
	.sub-head{
		margin-bottom: 1.25rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-left: 0.75rem;
		.test-title{
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-weight: 500;
			font-size: 1.6rem;
			color: #000000;
			line-height: 1.7rem;
		}
		.test-more{
			display: flex;
			align-items: center;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-size: 1.2rem;
			color: rgba(0,0,0,0.8);
			line-height: 1.41rem;
			img{
				width: 1.4rem;
				height: 1.4rem;
			}
		}
		.subject{
			display: flex;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-size: 1.4rem;
			color: #000000;
			line-height: 1.64rem;
			margin-right: 1.5rem;
			.tab{
				width: 5.5rem;
				height: 2.5rem;
				line-height: 2.5rem;
				text-align: center;
				border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
				margin-left: 5.8rem;
			}
			.actTab{
				background: rgb(100, 45, 113);
				color: #fff;
			}
		}
	}
	.test-cont{
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		.test-card{
			width: 18.35rem;
			height: 13rem;
			background: #FFFFFF;
			border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
			margin: 0.7rem;
			overflow: hidden;
			.test-bg{
				width: 18.35rem;
				height: 7.5rem;
				background-repeat: no-repeat;
				background-size: cover;
				position: relative;
				.test-study{
					position: absolute;
					top: 0.75rem;
					left: 0.75rem;
					width: 4.35rem;
					height: 1.8rem;
					background: rgba(141,51,0,0.77);
					border-radius: 3rem 3rem 3rem 3rem;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 0.8rem;
					color: rgb(100, 45, 113);
					line-height: 1.8rem;
					text-align: center;
				}
				.test-study{
					position: absolute;
					top: 0.75rem;
					left: 0.75rem;
					width: 4.35rem;
					height: 1.8rem;
					background: rgba(141,51,0,0.77);
					border-radius: 3rem 3rem 3rem 3rem;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 0.8rem;
					color: rgb(100, 45, 113);
					line-height: 1.8rem;
					text-align: center;
				}
				.test-study-end{
					background: #00d215;
					color: #fff;
				}
				.test-ruo{
						position: absolute;
						right: 0;
						top: 0;
						width: 2.45rem;
						height: 2.05rem;
				}
			}
			.test-name{
				margin: 1rem 0 0.6rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 500;
				font-size: 1.2rem;
				color: #1D1D1D;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				/*! autoprefixer: off */
				-webkit-box-orient: vertical;
			}
			.test-text{
				margin: 0 0.9rem 0.5rem;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 0.8rem;
				color: #74798C;
				line-height: 1rem;
			}
			.test-btn{
				display: flex;
				// align-items: center;
				justify-content: flex-start;
				margin: 0 0.9rem;
				.test-avator{
					width: 1.2rem;
					height: 1.2rem;
					border-radius: 6rem;
					margin-right: 0.4rem;
				}
				.test-teacher{
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 0.8rem;
					color: #1D1D1D;
					line-height: 1.12rem;
				}
				.test-save{
					background-image: url('../assets/heart-1.png');
					background-repeat: no-repeat;
					background-size: contain;
					width: 1.2rem;
					height: 1.2rem;
					margin-top: 1.22rem;
					margin-left: auto;
				}
				.test-save-act{
					background-image: url('../assets/heart.png');
				}
			}
		}
	}
}
</style>
